import PinVerifyForm from './PinVerifyForm';

export default PinVerifyForm;
